import { Box, LinearProgress, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import React from "react";

/**
 * Componente compacto para estatísticas de documentos
 */
export default function DocumentsStatistics({ statistics }) {
  const theme = useTheme();

  if (!statistics) {
    return null;
  }

  const { total, uploaded, pending, completionPercentage } = statistics;

  return (
    <Box
      sx={{
        p: 1.5,
        mb: 2,
        bgcolor: theme.palette.background.paper,
        borderRadius: 1,
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      {/* Progress Bar e Percentual */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
        <Box sx={{ flex: 1 }}>
          <LinearProgress
            variant="determinate"
            value={completionPercentage}
            sx={{
              height: 6,
              borderRadius: 3,
              bgcolor: theme.palette.grey[200],
              "& .MuiLinearProgress-bar": {
                bgcolor:
                  completionPercentage === 100
                    ? theme.palette.success.main
                    : completionPercentage >= 50
                    ? theme.palette.info.main
                    : theme.palette.warning.main,
                borderRadius: 3,
              },
            }}
          />
        </Box>
        <Typography
          variant="body2"
          sx={{ 
            fontWeight: 600,
            minWidth: 45,
            textAlign: "right",
            color: completionPercentage === 100 ? theme.palette.success.main : "text.primary",
          }}
        >
          {completionPercentage}%
        </Typography>
      </Box>

      {/* Contadores Compactos */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 700, color: theme.palette.success.main }}>
            {uploaded}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            completos
          </Typography>
        </Box>
        <Typography variant="caption" color="text.secondary">•</Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 700, color: theme.palette.error.main }}>
            {pending}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            pendentes
          </Typography>
        </Box>
        <Typography variant="caption" color="text.secondary">•</Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {total}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            total
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
